<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li>
                <router-link :to="{name: 'Dashboard'}">Dashboard</router-link>
              </li>
              <li>
                <span>Received Questions</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Received Questions
          </h3>
          <small>Review the question(s) you have received and interact with the question owner(s) through the platform.</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div  class="hpanel ">
        <div class="panel-heading">
          <h3 class="text-center font-bold">Questions <span>({{questions.length}})</span></h3>
        </div>
      </div>

      <div class="row projects" style="margin-bottom: 30px">
        <div class="col-lg-6" v-for="(question, key) in questions" v-bind:key="key" >
          <question-list-row :question="question" v-model="refresh"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import QuestionListRow from './../../components/receiveQuestion/QuestionListRow'

export default {
  components: {QuestionListRow},
  props: [],
  name: 'ReceiveQuestions',
  methods: {
    getResources: function () {
      this.axios.get('/questions/receive?relations={consultant,status}')
        .then((response) => {
          this.questions = response.data
        }).catch(function (error) {
        })
    },
    onProjectAction: function () {

    }
  },
  watch: {
    refresh: function (val) {
      this.refresh = false
      this.getResources()
    }
  },
  data () {
    return {
      questions: [],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      refresh: false
    }
  },
  mounted () {
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/receiveQuestion/ReceiveQuestions.vue